<template>
  <transition name="fade">
    <div class="mfp-wrap" v-if="isOpen">
      <div class="mfp-bg mfp-decide-later mfp-ready"></div>
      <div
        class="mfp-container"
        ref="container"
        @click="checkClick"
        @keydown="checkKeyDown"
        tabindex="1"
      >
        <div class="mfp-content">
          <div class="mfp-figure">
            <button
              title="Close (Esc)"
              type="button"
              class="mfp-close"
              @click.prevent="$emit('modal-close')"
            >
              ×
            </button>
            <figure>
              <AppImage
                class="mfp-img"
                :lazySrc="imageUrl"
                style="max-height: 815px"
              />
            </figure>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import AppImage from "./AppImage.vue";
export default {
  name: "DecideLaterModal",
  props: {
    isOpen: Boolean,
  },
  components: {
    AppImage,
  },
  data() {
    return {
      imageUrl:
        "//cdn.shopify.com/s/files/1/0250/3304/8148/t/121/assets/decide-later-popup-image.jpg?v=15591482406549092723",
    };
  },
  updated() {
    if (this.isOpen) {
      this.$refs.container.focus();
    }
  },
  methods: {
    checkClick(e) {
      if (e.target.classList.contains("mfp-container")) {
        this.$emit("modal-close");
      }
    },
    checkKeyDown(e) {
      if (e.keyCode == 27) {
        this.$emit("modal-close");
      }
    },
  },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.mfp-wrap {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1043;
  position: fixed;
  background: rgba(11, 11, 11, 0.8);
  outline: 0 !important;
  -webkit-backface-visibility: hidden;
}
.mfp-container {
  text-align: center;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  padding: 0 8px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.mfp-content {
  max-width: 100%;
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin: 0 auto;
  text-align: left;
  z-index: 1045;
}
.mfp-close {
  width: 100%;
  height: 44px;
  line-height: 44px;
  position: absolute;
  right: -6px;
  top: 0;
  text-decoration: none;
  text-align: center;
  padding: 0 0 18px 10px;
  font-style: normal;
  font-size: 2.5em;
  font-weight: 300;
  opacity: 1;
  font-family: Arial, Baskerville, monospace;
  overflow: visible;
  cursor: pointer;
  background: 0 0;
  border: 0;
  -webkit-appearance: none;
  display: block;
  outline: 0;
  z-index: 1046;
  -webkit-box-shadow: none;
  box-shadow: none;
  margin: 0;
  color: #fff;
  text-align: right;
  padding-right: 6px;
}
img.mfp-img {
  width: auto;
  max-width: 100%;
  height: auto;
  display: block;
  line-height: 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 40px 0 40px;
  margin: 0 auto;
}
figure {
  margin: 0;
}
.mfp-container::before {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}
</style>
